import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "navigation" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "size" }
const _hoisted_5 = { class: "sticker-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_StickerComponent = _resolveComponent("StickerComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, { to: { name: 'home' } }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode(" see all stickers ")
        ])),
        _: 1
      })
    ]),
    (_ctx.text)
      ? (_openBlock(), _createElementBlock("blockquote", _hoisted_3, " \"" + _toDisplayString(_ctx.text) + "\" ", 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.size.width.toFixed(1)) + "cm x " + _toDisplayString(_ctx.size.height.toFixed(1)) + "cm ", 1),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_StickerComponent, { sticker: _ctx.sticker }, null, 8, ["sticker"])
    ])
  ]))
}